<div class="manage-user-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-user-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-user-shell__sidebar"
    [class.manage-user-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-user-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-user-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-user-page">
      <section class="manage-user-page__heading">
        <div class="manage-user-page__heading-copy">
          <h2 class="app-title-serif">Manage User</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-user-page__add-button" (click)="openAddUserModal()">
          <span class="manage-user-page__add-icon">+</span>
          <span>Add New User</span>
        </button>
      </section>

      <section class="manage-user-page__filters app-card">
        <form class="manage-user-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-user-filters__field">
            <span class="app-form-label">Search</span>
            <div class="manage-user-filters__search">
              <span class="manage-user-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input class="app-form-input manage-user-filters__search-input" type="text" placeholder="Search" formControlName="search" />
            </div>
          </label>

          <label class="app-form-field manage-user-filters__field">
            <span class="app-form-label">Role</span>
            <select class="app-form-select" formControlName="role_id">
              <option value="all">All Roles</option>
	              @for (role of roles; track role.id) {
	                <option [value]="role.id">{{ role.display_name }}</option>
	              }
            </select>
          </label>

          <label class="app-form-field manage-user-filters__field">
            <span class="app-form-label">Status</span>
            <select class="app-form-select" formControlName="status">
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </label>

          <div>
            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button"
              [disabled]="isLoading"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>
        </form>
      </section>

      <section class="manage-user-page__table app-card">
        <div class="manage-user-page__table-wrap app-table-scroll">
          <table class="manage-user-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>
                  <button type="button" class="manage-user-table__sort-button" (click)="toggleSort('username')" [attr.aria-label]="'Sort by Username'">
                    <span>Username</span>
                    <svg class="manage-user-table__sort-icon" [class.manage-user-table__sort-icon--ascending]="isSortAscending('username')" [class.manage-user-table__sort-icon--descending]="isSortDescending('username')" viewBox="0 0 12 16" aria-hidden="true">
                      <path class="manage-user-table__sort-icon-up" d="M6 1 2 5h8L6 1Z"></path>
                      <path class="manage-user-table__sort-icon-down" d="m2 11 4 4 4-4H2Z"></path>
                    </svg>
                  </button>
                </th>
                <th>
                  <button type="button" class="manage-user-table__sort-button" (click)="toggleSort('first_name')" [attr.aria-label]="'Sort by First Name'">
                    <span>First Name</span>
                    <svg class="manage-user-table__sort-icon" [class.manage-user-table__sort-icon--ascending]="isSortAscending('first_name')" [class.manage-user-table__sort-icon--descending]="isSortDescending('first_name')" viewBox="0 0 12 16" aria-hidden="true">
                      <path class="manage-user-table__sort-icon-up" d="M6 1 2 5h8L6 1Z"></path>
                      <path class="manage-user-table__sort-icon-down" d="m2 11 4 4 4-4H2Z"></path>
                    </svg>
                  </button>
                </th>
                <th>
                  <button type="button" class="manage-user-table__sort-button" (click)="toggleSort('last_name')" [attr.aria-label]="'Sort by Last Name'">
                    <span>Last Name</span>
                    <svg class="manage-user-table__sort-icon" [class.manage-user-table__sort-icon--ascending]="isSortAscending('last_name')" [class.manage-user-table__sort-icon--descending]="isSortDescending('last_name')" viewBox="0 0 12 16" aria-hidden="true">
                      <path class="manage-user-table__sort-icon-up" d="M6 1 2 5h8L6 1Z"></path>
                      <path class="manage-user-table__sort-icon-down" d="m2 11 4 4 4-4H2Z"></path>
                    </svg>
                  </button>
                </th>
                <th>Email</th>
	                <th>Mobile Number</th>
	                <th>Active</th>
	                <th>Role</th>
	                <th>Assigned Generator/Substation</th>
	                <th>Rights</th>
	                <th>Actions</th>
	              </tr>
            </thead>
            <tbody>
	              @if (isLoading) {
	                <tr>
	                  <td colspan="11" class="manage-user-page__empty-state">Loading users...</td>
	                </tr>
              } @else if (filteredUsers.length) {
                @for (item of filteredUsers; track trackByUserId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no }}</td>
                    <td>{{ item.username || '-' }}</td>
                    <td>{{ item.first_name || '-' }}</td>
                    <td>{{ item.last_name || '-' }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.mobile_no || '-' }}</td>
                    <td>
                      <label class="app-status-switch manage-user-page__status-switch">
                        <input
                          class="app-status-switch__input"
                          type="checkbox"
                          [checked]="item.is_active"
                          [disabled]="isStatusUpdating(item)"
                          aria-label="Toggle user status"
                          (change)="handleActiveChange(item, $any($event.target).checked ? 'true' : 'false')"
                        />
                        <span class="app-status-switch__track" aria-hidden="true">
                          <span class="app-status-switch__thumb"></span>
                          <span class="app-status-switch__label app-status-switch__label--inactive">Inactive</span>
                          <span class="app-status-switch__label app-status-switch__label--active">Active</span>
                        </span>
                      </label>
	                    </td>
	                    <td>{{ item.role_display_name }}</td>
	                    <td>{{ getAssignedAssetLabel(item) }}</td>
	                    <td>
                      <button type="button" class="app-button app-button--secondary manage-user-page__rights-button" (click)="openRightsModal(item)">
                        {{ getRightSummary(item) }}
                      </button>
                    </td>
                    <td>
                      <div class="manage-user-page__actions">
                        <div class="app-row-action-menu">
                          <details class="app-row-action-menu__details">
                            <summary class="app-row-action-menu__toggle" aria-label="Open user actions">
                              <span class="app-row-action-menu__dots" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                              </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewUserModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                    <circle cx="12" cy="12" r="2.8"></circle>
                                  </svg>
                                </span>
                                <span>View</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditUserModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                    <path d="m13.5 6.5 4 4"></path>
                                  </svg>
                                </span>
                                <span>Edit</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteUserModal(item)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 6h18"></path>
                                    <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                    <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                    <path d="M10 10v6"></path>
                                    <path d="M14 10v6"></path>
                                  </svg>
                                </span>
                                <span>Delete</span>
                              </button>
                            </div>
                          </details>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
	              } @else {
	                <tr>
	                  <td colspan="11" class="manage-user-page__empty-state">No users found</td>
	                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowPagination()) {
          <div class="manage-user-page__pagination">
            <div class="manage-user-page__pagination-summary">
              <span>{{ getPaginationLabel() }}</span>
            </div>

            <div class="manage-user-page__pagination-actions">
              <button type="button" class="app-button app-button--secondary manage-user-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                Previous
              </button>

              <div class="manage-user-page__pagination-pages" aria-label="Pagination pages">
                @for (page of getPaginationItems(); track $index) {
                  @if (page === -1) {
                    <span class="manage-user-page__pagination-ellipsis" aria-hidden="true">...</span>
                  } @else {
                    <button
                      type="button"
                      class="manage-user-page__pagination-page"
                      [class.manage-user-page__pagination-page--active]="pagination.page_no === page"
                      [disabled]="isLoading"
                      (click)="goToPage(page)"
                    >
                      {{ page }}
                    </button>
                  }
                }
              </div>

              <button type="button" class="app-button app-button--secondary manage-user-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                Next
              </button>
            </div>

            <label class="manage-user-page__pagination-size">
              <span class="manage-user-page__pagination-size-label">Rows per page</span>
              <select class="app-form-select manage-user-page__pagination-select" [formControl]="pageSizeControl">
                @for (size of pageSizeOptions; track size) {
                  <option [ngValue]="size">{{ size }}/Page</option>
                }
              </select>
            </label>
          </div>
        }
      </section>
    </main>
  </div>

  @if (userModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-user-modal" open>
        <div class="manage-user-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit User' : modalMode === 'view' ? 'View User' : 'Add New User' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-user-modal__close" aria-label="Close modal" (click)="closeUserModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="userForm" (ngSubmit)="saveUser()">
          <div class="manage-user-modal__body">
            <div class="manage-user-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Email <span class="manage-user-modal__required">*</span></span>
                <input class="app-form-input" type="email" placeholder="name@company.com" formControlName="email" />
                @if (isRequiredFieldInvalid('email')) {
                  <section class="app-form-error">Email is required</section>
                }
                @if (isEmailInvalid()) {
                  <section class="app-form-error">Enter a valid email address</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">First Name <span class="manage-user-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="First name" formControlName="first_name" />
                @if (isRequiredFieldInvalid('first_name')) {
                  <section class="app-form-error">First name is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Last Name <span class="manage-user-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Last name" formControlName="last_name" />
                @if (isRequiredFieldInvalid('last_name')) {
                  <section class="app-form-error">Last name is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Mobile Number <span class="manage-user-modal__required">*</span></span>
                <input class="app-form-input" type="tel" inputmode="numeric" placeholder="Mobile number" formControlName="mobile_no" maxlength="15" (input)="sanitizeMobileNumber($event)" />
                @if (isRequiredFieldInvalid('mobile_no')) {
                  <section class="app-form-error">Mobile number is required</section>
                } @else if (isMobileNumberInvalid()) {
                  <section class="app-form-error">Mobile number must contain numbers only</section>
                }
              </label>

	              <label class="app-form-field">
	                <span class="app-form-label">Role <span class="manage-user-modal__required">*</span></span>
                <select class="app-form-select" formControlName="role_id">
                  <option [ngValue]="null">Select Role</option>
	                  @for (role of roles; track role.id) {
	                    <option [ngValue]="role.id">{{ role.display_name }}</option>
	                  }
                </select>
                @if (isRequiredFieldInvalid('role_id')) {
	                  <section class="app-form-error">Role is required</section>
	                }
	              </label>

	              @if (isGeneratorUserRoleSelected()) {
	                <div class="app-form-field">
	                  <span class="app-form-label">Generator <span class="manage-user-modal__required">*</span></span>
	                  <p-autocomplete
	                    [(ngModel)]="generatorSearchTerm"
	                    [ngModelOptions]="{ standalone: true }"
	                    [dropdown]="true"
	                    [suggestions]="filteredGeneratorOptions"
	                    [disabled]="modalMode === 'view'"
	                    placeholder="Select Generator"
	                    (completeMethod)="onGeneratorSearchInput($event)"
	                    (fieldBlur)="onGeneratorSearchBlur()"
	                  ></p-autocomplete>
	                  @if (isRequiredFieldInvalid('generator_id')) {
	                    <section class="app-form-error">Generator is required</section>
	                  }
	                </div>
	              }

	              @if (isSubstationUserRoleSelected()) {
	                <div class="app-form-field">
	                  <span class="app-form-label">Substation <span class="manage-user-modal__required">*</span></span>
	                  <p-autocomplete
	                    [(ngModel)]="substationSearchTerm"
	                    [ngModelOptions]="{ standalone: true }"
	                    [dropdown]="true"
	                    [suggestions]="filteredSubstationOptions"
	                    [disabled]="modalMode === 'view'"
	                    placeholder="Select Substation"
	                    (completeMethod)="onSubstationSearchInput($event)"
	                    (fieldBlur)="onSubstationSearchBlur()"
	                  ></p-autocomplete>
	                  @if (isRequiredFieldInvalid('substation_id')) {
	                    <section class="app-form-error">Substation is required</section>
	                  }
	                </div>
	              }
	            </div>
          </div>

          <div class="manage-user-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeUserModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (rightsModalOpen && selectedUser) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-user-rights-modal" open>
        <div class="manage-user-rights-modal__header">
          <div>
            <h3 class="app-title-serif">Manage Rights</h3>
            <p>{{ selectedUser.username || selectedUser.email }}</p>
          </div>

          <button type="button" class="app-button app-button--icon manage-user-rights-modal__close" aria-label="Close modal" (click)="closeRightsModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="manage-user-rights-modal__body">
          <div class="manage-user-rights-modal__bulk-actions">
            <label class="manage-user-rights-modal__bulk-toggle">
              <input type="checkbox" [checked]="areAllReadSelected()" (change)="toggleAllRead($any($event.target).checked)" />
              <span>Select all read</span>
            </label>

            <label class="manage-user-rights-modal__bulk-toggle">
              <input type="checkbox" [checked]="areAllWriteSelected()" (change)="toggleAllWrite($any($event.target).checked)" />
              <span>Select all write</span>
            </label>
          </div>

          <div class="manage-user-rights-modal__table-wrap app-table-scroll">
            <table class="manage-user-rights-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Menu Name</th>
                  <th>Read</th>
                  <th>Write</th>
                </tr>
              </thead>
              <tbody>
                @for (item of rightsDraft; track trackByRightId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no }}</td>
                    <td>
                      <div
                        class="manage-user-rights-table__menu-name"
                        [class.manage-user-rights-table__menu-name--child]="isChildRight(item)"
                        [style.--menu-depth]="item.depth"
                      >
                        <span class="manage-user-rights-table__branch" aria-hidden="true"></span>
                        <div class="manage-user-rights-table__menu-copy">
                          <span class="manage-user-rights-table__menu-title">{{ item.menu_name }}</span>
                          @if (item.parent_menu_name) {
                            <span class="manage-user-rights-table__menu-parent">Child of {{ item.parent_menu_name }}</span>
                          }
                        </div>
                      </div>
                    </td>
                    <td>
                      <label class="manage-user-rights-table__check">
                        <input type="checkbox" [checked]="item.is_read" (change)="onReadChange(item, $any($event.target).checked)" />
                        <span>Read</span>
                      </label>
                    </td>
                    <td>
                      <label class="manage-user-rights-table__check">
                        <input type="checkbox" [checked]="item.is_write" (change)="onWriteChange(item, $any($event.target).checked)" />
                        <span>Write</span>
                      </label>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="manage-user-rights-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeRightsModal()">Cancel</button>
          <button type="button" class="app-button app-button--primary" (click)="saveRights()">Submit</button>
        </div>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedUser) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-user-delete">
        <div class="manage-user-delete__header">
          <div class="manage-user-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete User</h3>
            <p>This action will deactivate the user</p>
          </div>
        </div>

        <p class="manage-user-delete__copy">
          Are you sure you want to delete <strong>{{ selectedUser.email }}</strong>?
        </p>

        <div class="manage-user-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
